import { defineStore } from 'pinia';

export const useDokStore = defineStore('dok', {
    state: () => ({
        // Dokumenten-Daten
        kanal: '',
        vnVorname: '',
        vnNachname: '',
        tarife: [],
        aokMitarbeiter: false,
        
        // Status
        hasDownload: false,
        isDownloading: false,
        errorMessage: '',
    }),
    
    getters: {
        /**
         * Prüft ob der Download abgeschlossen wurde
         * @returns {boolean}
         */
        isDownloadComplete: (state) => {
            return state.hasDownload;
        },
        
        /**
         * Prüft ob ein Fehler vorliegt
         * @returns {boolean}
         */
        hasError: (state) => {
            return state.errorMessage !== '';
        },
    },
    
    actions: {
        /**
         * Setzt den Store zurück
         */
        initializeStore() {
            console.log('[DokStore] Store wird zurückgesetzt');
            this.kanal = '';
            this.vnVorname = '';
            this.vnNachname = '';
            this.tarife = [];
            this.aokMitarbeiter = false;
            this.hasDownload = false;
            this.isDownloading = false;
            this.errorMessage = '';
        },
        
        /**
         * Löscht nur die Fehlerinformationen
         */
        resetError() {
            this.errorMessage = '';
        },
    },
    
    persist: {
        storage: sessionStorage
    }
});
